import { render, staticRenderFns } from "./UcSuggestRegisterEntryOption.yaml?vue&type=template&id=b20acc36&component"
import script from "./UcSuggestRegisterEntryOption.yaml?vue&type=script&lang=ts&component"
export * from "./UcSuggestRegisterEntryOption.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports